import {
  AUCTIONS_FETCH_JEWEL_LISTING,
  AUCTIONS_PUBLIC_FETCH_JEWEL_LISTING,
  BID_MODAL_CREATE_BID,
  BID_MODAL_DELETE_BID,
  AUCTIONS_JEWEL_LISTING_CREATE_FAVORITE,
  AUCTIONS_JEWEL_LISTING_DELETE_FAVORITE,
  BID_MODAL_RESOLVE_OFFER,
  AUCTIONS_HIGHEST_BID_CHANGED
} from 'constants/action-types';

const initialState = {
  listing: {
    requesterBidPrice: null,
    buyerMaxBidAmount: null,
    listingState: null,
    auctionId: null,
    listingId: null,
    highestBidPrice: null,
    jewelries: null,
    auctionType: null,
    buyNowPrice: null,
    catalogNumber: null,
    endDate: null,
    auctionStatus: null,
    highestBidBuyerId: null,
    bidIncrementAmount: null
  },
  isJewelListingLoading: true
};

export const jewelListing = (state = initialState, action) => {
  switch (action.type) {
    case AUCTIONS_HIGHEST_BID_CHANGED: {
      return {
        ...state,
        listing:
          state.listing.listingId === action.payload.data.ListingId
            ? {
                ...state.listing,
                highestBidPrice: action.payload.data.BidPrice,
                bidIncrementAmount: action.payload.data.BidIncrementAmount,
                startPrice: action.payload.data.BidPrice ? null : state.listing.startPrice,
                sellerSaleTotalPriceWithCommission: state.listing.sellerCommission
                  ? action.payload.data.BidPrice -
                    (action.payload.data.BidPrice * state.listing.sellerCommission) / 100
                  : null,
                endDate: action.payload.data.EndDateTime && action.payload.data.EndDateTime
              }
            : state.listing
      };
    }
    case AUCTIONS_FETCH_JEWEL_LISTING.pending:
    case AUCTIONS_PUBLIC_FETCH_JEWEL_LISTING.pending:
      return {
        ...state,
        listing: initialState.listing,
        isJewelListingLoading: true
      };
    case AUCTIONS_FETCH_JEWEL_LISTING.success: {
      return {
        ...state,
        listing: action.payload.listings && action.payload.listings[0],
        isJewelListingLoading: false
      };
    }
    case AUCTIONS_PUBLIC_FETCH_JEWEL_LISTING.success:
      return {
        ...state,
        listing: action.payload[0],
        isJewelListingLoading: false
      };
    case BID_MODAL_CREATE_BID.pending:
      return {
        ...state,
        listing: { ...state.listing, requesterBidPrice: null }
      };
    case BID_MODAL_CREATE_BID.success:
      return {
        ...state,
        listing: { ...state.listing, requesterBidPrice: action.payload.bidPrice }
      };
    case BID_MODAL_DELETE_BID.success:
      return {
        ...state,
        listing: { ...state.listing, requesterBidPrice: null }
      };
    case AUCTIONS_JEWEL_LISTING_CREATE_FAVORITE.success:
      return {
        ...state,
        listing: { ...state.listing, isFavorite: true }
      };
    case AUCTIONS_JEWEL_LISTING_DELETE_FAVORITE.success:
      return {
        ...state,
        listing: { ...state.listing, isFavorite: false }
      };
    case BID_MODAL_RESOLVE_OFFER.success:
      return {
        ...state,
        listing: { ...state.listing, listingState: action.payload.listingState }
      };
    default:
      return state;
  }
};
